// ChatContext.tsx
import React, { createContext, useContext, useState } from 'react';

type Message = {
  id: string;
  type: 'user' | 'ai' | 'error';
  content: string;
  timestamp: Date;
};

type TaskConversations = {
  [taskName: string]: Message[];
};

const ChatContext = createContext<{
  taskConversations: TaskConversations;
  setTaskMessages: (taskName: string, messages: Message[]) => void;
  addTaskMessage: (taskName: string, message: Message) => void;
} | null>(null);

export const ChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [taskConversations, setTaskConversations] = useState<TaskConversations>({});

  const setTaskMessages = (taskName: string, messages: Message[]) => {
    setTaskConversations(prev => ({
      ...prev,
      [taskName]: messages
    }));
  };

  const addTaskMessage = (taskName: string, message: Message) => {
    setTaskConversations(prev => ({
      ...prev,
      [taskName]: [...(prev[taskName] || []), message]
    }));
  };

  return (
    <ChatContext.Provider value={{ taskConversations, setTaskMessages, addTaskMessage }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) throw new Error("useChat must be used within ChatProvider");
  return context;
};
